// extracted by mini-css-extract-plugin
export default {"aboutText":"About_aboutText__HMZGP","imgs":"About_imgs__cgEIO"};